<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>icons / 24x24 / upload</title>
    <g
      id="icons-/-24x24-/-upload"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <g
        id="upload"
        transform="translate(3.000000, 3.000000)"
        stroke="#97ABBE"
        stroke-width="2"
      >
        <path
          d="M18,12 L18,16 C18,17.1045695 17.1045695,18 16,18 L2,18 C0.8954305,18 0,17.1045695 0,16 L0,12"
          id="Path"
        ></path>
        <polyline id="Path" points="14 5 9 0 4 5"></polyline>
        <line x1="9" y1="0" x2="9" y2="12" id="Path"></line>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "icon"
};
</script>